
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Popup from 'vux/src/components/popup/index.vue'

import selectSupply from '@/components/browse/select-supply';
import selectNeed from '@/components/browse/select-need';
import selectDrive from '@/components/browse/select-drive';

export default {
components: { Grid, GridItem, Popup,selectSupply,selectNeed,selectDrive},
data() {
return {
isNew:false,
detailId: null,
dto: {},
en: 0,
newDetail:[],
selectModel:'base',
options:[
{
label:'快递',
value:'EXPRESS'
},
{
label: '物流',
value:'LOGISTICS'
},
{
label: '自送',
value:'SELF_DELIVER'
}
],
value:'',
checked:'',
checkList:[],
dialogFormVisible: false,
status:'',
formLabelWidth: '120px',
rules:{
expDelDate:[{required:true,message:'发货日期不能空',trigger:'change'}],
expArrDate:[{required:true,message:'到货日期不能空',trigger:'change'}],
shipMethod:[{required:true,message:'送货方式不能空',trigger:'change'}],
}
}
},
computed: {


pickerBeginDateBefore() {
let date = new Date(); 
let year = date.getFullYear().toString()


let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();

let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString();
let expDelDate = year + '-' + month + '-' + day  
this.dto.expDelDate = date;
return {
disabledDate: time => {
let endDateVal = this.dto.expArrDate;
if (endDateVal) {
return time.getTime() > new Date(endDateVal).getTime();
}else {
return time.getTime() > Date.now();   
}
},
shortcuts:[{
text: '今天',
align:'bottom',
onClick(picker) {
picker.$emit('pick', new Date());
}
}]
}
},
pickerBeginDateAfter() {
return {
disabledDate: time => {
let beginDateVal = this.dto.expDelDate;
if (beginDateVal) {
return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(beginDateVal).getTime() - 8.64e7;
}
},
}
},
},
methods: {
getCurrent(){
this.$get('api/person/current').then((res) => {
this.dto.founderName = res.name;
})
},
getDetail() {
let initData = JSON.parse(localStorage.getItem("asnData"));
this.dto={
supplier: initData[0].supplier,
plant: initData[0].plant,
shipAddress: initData[0].shipAddress,
contact: initData[0].contact,
plantCodeTg: initData[0].plantCodeTg,
attachment: {},
orderDetails: initData,
status: 'DRAFT',
};
for(let i=0;i<this.dto.orderDetails.length;i++){
this.dto.orderDetails[i].checked = false;
}
},

changeShowModel(str){
this.selectModel = str;
},
backSourceList() {
this.$router.go(-1);
},
switchTabItem(orderDetail,i){
this.$set(orderDetail,'list',i);
},
elDatePickerOnFocus:function(){
document.activeElement.blur();
},
changeSup(dto) {
if (dto.show) {
this.$set(dto,'show',false);
return;
}
this.$set(dto,'show',true);
},
submit(){
if(!this.dto.shipMethod){
this.$message.error('请选择送货方式！');
return;
}
if(!this.dto.expDelDate){
this.$message.error('请选择发货日期！');
return;
}
if(!this.dto.expArrDate){
this.$message.error('请选择到货日期！');
return;
}
for(let i=0;i<this.dto.orderDetails.length;i++){
let itemNo = (i+1)*10
this.dto.orderDetails[i].itemNo = itemNo.toString();
let maxAlw = this.dto.orderDetails[i].confirmCount * (1 + this.dto.orderDetails[i].alw) - this.dto.orderDetails[i].asnReceiveQty;
if (this.dto.orderDetails[i].delQty == 0) {
this.$message.error('送货数量不能为0！');
return;
}
if(this.dto.orderDetails[i].delQty > maxAlw){
this.$message.error('第'+ itemNo +'行送货数量不能超过可创建送货单数量上限:' + maxAlw);
return;
}
}
if(this.dto.orderDetails.length<=0){
this.$message.error('明细不可为空！');
}else {
this.$put('api/asn',this.dto).then((res) => {
console.log('数据提交成功');
console.log(res);
this.$message({
message: '提交成功',
type: 'success'
});
this.$router.replace("/asn/asn-list");
}).catch(error => {
console.log('数据提交失败');
console.log(error);
});
}
},
asnDelete(){
this.$del('api/asn/' + this.detailId).then((data) => {
this.$message({
message: '删除成功',
type: 'success'
});
this.$router.replace("/asn/asn-list");
}).catch(error => {
console.log('数据提交失败');
console.log(error);
})
},
changeBox(orderDetail,index){
let checkListGroup = [];
let count = 0;
for (let i=0;i<this.dto.orderDetails.length;i++){
if(this.dto.orderDetails[i].checked == true){
checkListGroup.push(this.dto.orderDetails[i]);
count++;
}
}
this.checkList= checkListGroup;
console.log(index);
console.log(this.checkList)
},
selectConsignor(){
this.$refs.personRef.showPop();
},
getPerson(result) {

this.dto.consignor = result.linkman;
this.dto.consignorTel = result.linkmanPhone;
console.log(result);
},
getNeed(result){
this.newDetail.push(result);
this.newDetail.forEach(item => {
item.receiveQty = 0;
item.poNo = item.orderNo;
item.purOrderErpNo = item.orderNoERP;
item.poItemNo = item.purOrderDetail.itemNo;
item.alw = item.purOrderDetail.alw;
item.deliveryDate = item.requireGoodsDateFrom;
item.requireQty = item.confirmCount;
item.delQty = item.requireQty - item.asnCrtQty - item.asnReceiveQty;
item.supplier = {
id: item.supplierId,
supplierName: item.supplierName,
supplierCode: item.supplierCode,
};
item.material = item.material;
item.materialName = item.material.matName;
if(item.material != null){
if(!item.material) {
item.material = {
minPackNum: 0
}
}
item.minPackNum = item.material['minPackNum'];
if (item.minPackNum) {

item.boxQty = Math.ceil(item.delQty / item.minPackNum);
}
}
item.unit = item.purOrderDetail.orderUnit;
item.checked = false;
item.requireGoodsPlanRow = { id: item.id,planType: item.planType };
item.sourceId = item.id;
delete item.id;
});
console.log(this.newDetail[0]);
this.dto.orderDetails.push(this.newDetail[0]);
},
selectDriver(){
this.$refs.driverRef.showPop();
},
getsDriver(result){
this.dto.carrier = result.name;
this.dto.carrierTel = result.phone;
this.dto.carNumber = result.carNumber;
},
addSource(){
this.$refs.needRef.showPop();
},
copyDetails(){
if(this.checkList.length<=0){
this.$message.error('请至少选择一条记录！');
}else {
for (let i=0;i<this.checkList.length;i++){
let copyList = this.checkList[i];
delete copyList.id;
this.dto.orderDetails.push(copyList);
this.dto.orderDetails[i].checked=false;
}
}
},
deleteDetails(orderDetail,index){

if(this.checkList.length<=0){
this.$message.error('请至少选择一条记录！');
}else {
for(let i=0; i<this.checkList.length;i++){






this.dto.orderDetails.splice(index, 1);
}

}

},
delDetails(orderDetail,index){

this.dto.orderDetails.splice(index, 1);








},

},
mounted() {

this.getCurrent();
this.getDetail();
}
}



// WEBPACK FOOTER //
// ./src/page/asn/view/creat.vue